<template>
  <div class="change-password-modal" v-if="visible">
    <div class="modal-overlay" @click="close">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>🔐 修改密码 / Change Password</h3>
          <button class="close-btn" @click="close">×</button>
        </div>
        
        <div class="modal-body">
          <div class="form-group">
            <label>旧密码 / Old Password</label>
            <input type="password" v-model="form.oldPassword" placeholder="请输入旧密码" />
          </div>
          
          <div class="form-group">
            <label>新密码 / New Password</label>
            <input type="password" v-model="form.newPassword" placeholder="至少 6 位" />
          </div>
          
          <div class="form-group">
            <label>确认新密码 / Confirm New Password</label>
            <input type="password" v-model="form.confirmPassword" placeholder="再次输入新密码" />
          </div>
          
          <div v-if="errorMsg" class="error-msg">⚠️ {{ errorMsg }}</div>
        </div>
        
        <div class="modal-footer">
          <button class="btn-cancel" @click="close">取消 / Cancel</button>
          <button class="btn-confirm" @click="submit" :disabled="submitting">
            {{ submitting ? '提交中...' : '保存 / Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'ChangePasswordModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      errorMsg: '',
      submitting: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = { oldPassword: '', newPassword: '', confirmPassword: '' };
        this.errorMsg = '';
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    async submit() {
      this.errorMsg = '';
      
      if (!this.form.oldPassword) {
        this.errorMsg = '请输入旧密码';
        return;
      }
      if (!this.form.newPassword || this.form.newPassword.length < 6) {
        this.errorMsg = '新密码长度不能少于 6 位';
        return;
      }
      if (this.form.newPassword !== this.form.confirmPassword) {
        this.errorMsg = '两次输入的新密码不一致';
        return;
      }
      
      this.submitting = true;
      try {
        const resp = await api.post('/auth/change-password', this.form);
        // api.js 拦截器已解包 data，成功时 resp 就是业务数据
        this.$toast?.success(resp || '密码修改成功');
        this.close();
      } catch (error) {
        this.errorMsg = error.response?.data?.message || error.message || '修改失败';
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.change-password-modal .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  opacity: 1 !important;
  visibility: visible !important;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  margin-bottom: 8px;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.form-group input:focus {
  border-color: #667eea;
}

.error-msg {
  background: #fff2f0;
  color: #ff4d4f;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel, .btn-confirm {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
}

.btn-cancel {
  background: #f0f0f0;
  color: #666;
}

.btn-confirm {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
